import { Component } from 'preact';
import styled from 'styled-components';
import 'preact-material-components/style.css';


const MainHeader = styled.div`
    background-color: none;
    background: ${props => props.theme.colors.backgroundDark3};
    background: -webkit-linear-gradient(${props => props.theme.colors.backgroundDark2}, ${props => props.theme.colors.backgroundDark3});
    background: linear-gradient(${props => props.theme.colors.backgroundDark2}, ${props => props.theme.colors.backgroundDark3});
    height: 5em;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 110;
    display: flex;
`

const MenuIcon = styled.svg`
    padding: 0;
    width: 1.2em;
    height: 0.9em;
    fill: #fff;
`

const MenuText = styled.p`
    font-weight: 200;;
    font-size: 0.6em;
    margin: 0;
    color: #fff;
    padding-top: 0.4em;
`

const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 1em;
    top: 55%;
    transform: translateY(-50%);
`

const Logo = styled.img`
    width: 100%;
    position: absolute;
    left: 50%;
    top: 55%;
    transform: translate(-50%, -50%);
`

const HomeLink = styled.a`
    width: 40%;
    max-width: 175px;
    height: 5em;
    position: relative;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
`
class TopBar extends Component {

    render(props) {
        return (
            <MainHeader>

                <HomeLink href="/">
                    <Logo src={props.logo.imageUrl} alt={props.logo.alt} />
                </HomeLink>

                <MenuWrapper onClick={props.toggleMenu}>
                    <MenuIcon id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.75 15.78"><path d="M20,5.76H4.26a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2" transform="translate(-3.28 -3.79)" /><path d="M20,12.66H4.26a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2" transform="translate(-3.28 -3.79)" /><path d="M20,19.56H4.26a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2" transform="translate(-3.28 -3.79)" /></MenuIcon>
                    <MenuText>{props.content[0].menuLabel}</MenuText>
                </MenuWrapper>

            </MainHeader>
        );
    }
}

export default TopBar;





// WEBPACK FOOTER //
// ./components/header/GlobalHeader.jsx